module.exports = __webpack_public_path__ + "img/home-new.17bdfbd7.png";